import React from "react";
import CustomText from "./CustomText";
import Colors from "../config/Colors";
import * as Sentry from "@sentry/react";
interface PoweredProps {
  marginTop?: number | string;
  marginBottom?: number | string;
  marginLeft?: number | string;
  marginRight?: number | string;
  color?: string;
}

function Powered({
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  color,
}: PoweredProps) {
  return (
    <div className={"containerPoweredContainer"}>
      <CustomText
        weight="500"
        size="smallMedium"
        color={color || Colors.brownPrimary}
      >
        Powered by
      </CustomText>
      <CustomText
        weight="700"
        size="medium"
        color={color || Colors.brownPrimary}
      >
        Mamba Fantasy
      </CustomText>
    </div>
  );
}

export default Powered;
